import type { ImageAttachment, UserInputContext } from "../types"

export type BlockedFeature = { kind: "images" } | { kind: "mcp" }

export interface NestTaskCreationFeatureInput {
    images: ImageAttachment[]
    enabledMcpServerIds?: string[]
}

export interface NestTurnFeatureInput {
    input: UserInputContext
    enabledMcpServerIds: string[]
}

export function blockedFeatureForCreation(input: NestTaskCreationFeatureInput): BlockedFeature | null {
    if (input.images.some((image) => !image.attachmentId)) return { kind: "images" }
    if ((input.enabledMcpServerIds?.length ?? 0) > 0) return { kind: "mcp" }
    return null
}

export function blockedFeatureForTurn(input: NestTurnFeatureInput): BlockedFeature | null {
    if (input.input.images.some((image) => !image.attachmentId)) return { kind: "images" }
    if (input.enabledMcpServerIds.length > 0) return { kind: "mcp" }
    return null
}

export function describeBlockedFeature(feature: BlockedFeature): string {
    switch (feature.kind) {
        case "images":
            return "Image turns require Nest attachment-backed images"
        case "mcp":
            return "MCP-backed turns are not available until Nest has a generic MCP runtime surface"
    }
}
